import React from 'react';

function TextInput({ description, type, ...inputProps }) {
    return (
        <div className='input'>
            <label className='input__label'>{description}</label>
            <input className='input__field' type={type || 'text'} {...inputProps} />
        </div>
    )
}

export default TextInput
